<!--
 * @Author: Latte
 * @Date: 2021-08-05 12:10:30
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-27 16:02:23
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\diagnosisManagement\roleUserMgt\index.vue
-->

<template>
  <div class="app-container">
    <!-- 会诊角色用户管理 -->
    <el-card class="-card">
      <!-- 工具栏 -->
      <div class="topbar">
        <div>
          <el-input
            v-model="searchValue"
            placeholder="请输入会诊角色ID"
            size="small"
            prefix-icon="el-icon-search"
            class="search-input"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            :disabled="!searchValue"
            @click.stop="search()"
            >搜索</el-button
          >
          <el-button
            type="info"
            icon="el-icon-refresh"
            size="small"
            @click.stop="reset()"
            >重置</el-button
          >
        </div>
      </div>
    </el-card>

    <!-- 会诊角色用户管理内容 -->
    <el-table
      ref="table"
      border
      :data="allUserList"
      :header-cell-style="{ background: '#F5F7FA' }"
      style="width: 100%; margin-bottom: 20px"
      v-loading="loading"
    >
      <el-table-column
        prop="consultationUserID"
        label="会诊角色ID"
        width="150"
      ></el-table-column>
      <el-table-column label="姓名" width="150">
        <template slot-scope="scope">
          {{ formatName(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="fullWorkPlace" label="工作地点">
        <template slot-scope="scope">
          {{ formatPlace(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="company" label="单位名称"></el-table-column>
      <el-table-column prop="role" label="角色类型">
        <template slot-scope="scope">
          {{ formatRole(scope.row.role) }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="small" type="danger" @click.stop="deleteRole(scope)"
            >取消认证</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-show="totalCount > pageSize"
      background
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import {
  getAllRoleList,
  getRoleDetail,
} from "@/api/system/diagnosisManagement/diagnosticRoleApplication";

import {
  getAllUserList,
  getUserDetail,
  deleteUser,
} from "@/api/system/diagnosisManagement/diagnosticRoleManagement";

import { handleRes } from "@/utils/handleRes";
export default {
  data() {
    return {
      activeIndex: "0", // 当前索引
      loading: false, // 加载开关
      searchValue: "", // 搜索内容
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      allUserList: [], // 全部角色用户列表
    };
  },

  computed: {
    formatRole() {
      return function (row) {
        switch (row) {
          case 0:
            return "医生";
          case 1:
            return "会诊专家";
          case 2:
            return "医生&会诊专家";
        }
      };
    },

    formatName: {
      get() {
        return function (row) {
          let fullName = row.firstName + row.lastName;
          return fullName;
        };
      },
    },

    formatPlace: {
      get() {
        return function (row) {
          let fullWorkPlace =
            row.workProvince + row.workCity + row.workDistrict;
          return fullWorkPlace;
        };
      },
    },
  },

  created() {
    this.refreshCurrentList();
  },

  methods: {
    /**
     * 搜索
     */
    search() {
      this.loading = true;

      this.currentPage = 1;
      this.getRoleDetail();

      this.utils.stopLoading(this);
    },

    /**
     * @description: 获取单个角色用户详情
     * @param {*}
     * @return {*}
     */
    getRoleDetail() {
      const searchValue = Number(this.searchValue);
      const params = {
        consultationUserID: searchValue,
      };
      console.log("typeof(searchValue)", typeof searchValue);

      getRoleDetail(params).then((res) => {
        console.log(" -----------------------");
        console.log("getRoleDetail , res", res);
        console.log(" -----------------------");

        this.allUserList = [];
        this.allUserList[0] = res.data;
        console.log(" -------------------------------------------------");
        console.log("getRoleDetail , this.allUserList", this.allUserList);
        console.log(" -------------------------------------------------");
        this.allUserList.forEach((element) => {
          element.fullName = element.firstName + element.lastName;
          element.fullWorkPlace =
            element.workCity + element.workDistrict + element.workProvince;
        });
        this.totalCount = 1;

        handleRes(res);
      });
    },

    /**
     * 刷新列表
     */
    refreshCurrentList() {
      this.getAllRoleList();
    },

    /**
     * @description: 翻页
     * @param {*} currentPage
     * @return {*}
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.refreshCurrentList();
    },

    /**
     * 获取所有会诊角色用户列表
     */
    getAllRoleList() {
      this.loading = true;
      const params = {
        keyword: "",
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        sortName: "",
        sortOrder: "",
        where: "",
      };
      getAllRoleList(params).then((res) => {
        this.allUserList = res.data.list;
        console.log(" --------------------------------------------------");
        console.log("getAllRoleList , this.allUserList", this.allUserList);
        console.log(" --------------------------------------------------");

        this.totalCount = res.data.total;
        console.log(" ------------------------------------------------");
        console.log("getAllRoleList , this.totalCount", this.totalCount);
        console.log(" ------------------------------------------------");

        this.allUserList.forEach((element) => {
          element.fullName = element.firstName + element.lastName;
          element.fullWorkPlace =
            element.workCity + element.workDistrict + element.workProvince;
        });

        this.utils.stopLoading(this);
      });
    },

    /**
     * @description: 取消用户角色认证
     * @param {*}
     * @return {*}
     */
    deleteRole(scope) {
      this.loading = true;
      const params = {
        consultationUserID: scope.row.consultationUserID,
      };
      console.log(
        " ----------------------------------------------------------------------"
      );
      console.log(
        "deleteRole , scope.row.consultationUserID",
        scope.row.consultationUserID
      );
      console.log(
        " ----------------------------------------------------------------------"
      );

      deleteUser(params).then((res) => {
        console.log(" --------------------");
        console.log("deleteRole , res", res);
        console.log(" --------------------");
        handleRes(res);

        this.refreshCurrentList();
        this.utils.stopLoading(this);
      });
    },
  },
};
</script>

<style>
</style>